import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IOutletDto } from '../models';
import {
  IShipdayOrderDto,
  IShipDayOrderUpdateDto,
} from '../models/shipday.model';

@Injectable()
export class ShipDayService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getOutlet(id: string): Observable<IOutletDto> {
    return this.get(`shipday/outlet/${id}`);
  }

  public saveOrder(model: IShipdayOrderDto): Observable<IApiResponse<boolean>> {
    return this.post(`shipday/saveorder`, model);
  }

  public updateOrderStatus(
    model: IShipDayOrderUpdateDto,
  ): Observable<IApiResponse<boolean>> {
    return this.put(`shipday/order/status`, model);
  }
}
